import React, { useEffect, useRef } from 'react'

import { useForm, FormContext } from 'react-hook-form'
import useSnackbar from 'hooks/useSnackbar'

import { FileUploadInput, Card } from 'components'

import * as service from 'service'
import helpers from 'helpers'

const AttachmentForm = ({ isDisbled, setLoading, dataPdca, refresh }) => {
  const snackbar = useSnackbar()
  const uploadingRef = useRef(false)

  const formMethods = useForm({
    defaultValues: {
      attachments: dataPdca?.attachments || [],
    },
  })

  const { watch, reset } = formMethods

  const attachments = watch('attachments')

  useEffect(() => {
    if (!dataPdca?.id || !attachments || uploadingRef.current) return

    const newFiles = Array.from(attachments).filter((f) => f instanceof File)

    if (newFiles.length === 0) return

    const autoUpload = async () => {
      uploadingRef.current = true
      setLoading(true)
      try {
        await service.dponet.pdca.uploadFiles({
          pdcaId: dataPdca.id,
          attachments: newFiles,
        })

        snackbar.open({
          message: 'Documento(s) anexado(s) com sucesso',
          variant: 'success',
        })

        refresh && refresh()
      } catch (error) {
        snackbar.open({
          message:
            helpers.formatters.errorMessage(error?.response?.data?.error) ||
            'Ocorreu uma falha ao anexar o(s) documento(s). Tente novamente.',
          variant: 'error',
        })
      } finally {
        setLoading(false)
        uploadingRef.current = false
      }
    }

    autoUpload()
  }, [attachments]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    reset({ attachments: dataPdca?.attachments || [] })
  }, [dataPdca]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleRemoveApiFile = async (attachmentId) => {
    setLoading(true)
    try {
      await service.dponet.pdca.destroyFile({
        pdcaId: dataPdca?.id,
        fileId: attachmentId,
      })

      snackbar.open({
        message: 'Documento removido com sucesso',
        variant: 'success',
      })

      refresh && refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu uma falha ao remover o documento. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Card title="Anexe os documentos">
      <FormContext {...formMethods}>
        <FileUploadInput
          controlName="attachments"
          multiple
          controllerBar
          hasDownloadFile
          onRemoveApiFile={handleRemoveApiFile}
          disabled={isDisbled}
        />
      </FormContext>
    </Card>
  )
}

export default AttachmentForm
